import { createAsyncThunk } from '@reduxjs/toolkit';

import { SliceNameEnum } from '@app/enums';
import { AccommodationTilesResponse } from '@app/helpers/accommodation-tiles.helpers';
import { getListingTiles } from '@app/helpers/listing.helpers';
import { CampaignListingEnriched, SearchCriteria, SearchFilters } from '@app/models';
import { CmsListingService } from '@app/services/cms-listing.service';

export const fetchCampaignListingMeta = createAsyncThunk<
    CampaignListingEnriched | null,
    { slug?: string; documentId?: string; preview?: boolean },
    { rejectValue: string }
>(
    `${SliceNameEnum.Listing}/fetch-custom-listing-meta`,
    async ({ slug, documentId, preview = false }, { rejectWithValue }) => {
        try {
            return await CmsListingService.instance.getCampaignListing(slug, documentId, preview);
        } catch (error) {
            const message =
                error instanceof Error ? error.message : 'Failed to fetch listing meta data';
            return rejectWithValue(message);
        }
    },
);

export const fetchListingItems = createAsyncThunk<
    AccommodationTilesResponse | null,
    {
        searchCriteria: SearchCriteria;
        searchFilters: SearchFilters;
        page?: number;
        campaignListingId?: string;
        noPrice?: boolean;
    },
    { rejectValue: string }
>(
    `${SliceNameEnum.Listing}/fetch-listing-items`,
    async (
        { searchCriteria, searchFilters, page = 1, campaignListingId, noPrice },
        { rejectWithValue },
    ) => {
        try {
            return await getListingTiles({
                searchCriteria,
                searchFilters,
                page,
                campaignListingId,
                noPrice,
            });
        } catch (error) {
            return rejectWithValue(
                error instanceof Error ? error.message : 'Failed to fetch listing data',
            );
        }
    },
);
